export enum ModuleType {
  Regular = 'regular',
  Project = 'project',
}
